export const UPDATE_APPOINTMENT_NOTE = 'booking/UPDATE_APPOINTMENT_NOTE';
export const UPDATE_APPOINTMENT_NOTE_SUCCESS =
  'booking/UPDATE_APPOINTMENT_NOTE_SUCCESS';
export const UPDATE_APPOINTMENT_NOTE_ERROR =
  'booking/UPDATE_APPOINTMENT_NOTE_ERROR';

export const UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT =
  'UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT';
export const UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_SUCCESS =
  'UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_SUCCESS';
export const UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_ERROR =
  'UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_ERROR';
